export const WIDGET_TYPES = {
  AGENDA: 'agenda',
  SCHEDULE: 'schedule',
  // SB-9570: Rooms view — one column per room, sessions stacked by time.
  ROOMS: 'rooms',
  SESSIONS: 'session',
  SPEAKERS: 'speaker',
  SPEAKERS_GALLERY: 'speaker-gallery',
  // SB-9273: Content Gallery head — reads the public gallery API directly
  // (no embed row / async-data), so it has its own SDK entry and is not part
  // of the all-widgets bundle.
  CONTENT_GALLERY: 'content-gallery',
  // MKT-045: attendee Advocacy share card for registration confirmation
  // pages — calls /r/a/... as JSON, own SDK entry like content-gallery.
  ADVOCACY_ATTENDING: 'advocacy-attending',
  // ASK-021b: website Ask widget — a floating chat launcher added by a
  // one-line <script data-key> (its own <sessionboard-ask> element, not
  // <sessionboard-embed>; src/widgets/ask/).
  ASK: 'ask',
};

export const MODAL_TYPES = {
  SESSION: 'session-modal',
  SPEAKER: 'speaker-modal',
  SUBSESSION: 'subsession-modal',
};

// This will be replaced at build time with the actual value
export const API_URL = process.env.API_URL;

// Map filter options to internal names
export const FILTER_MAP = {
  filter_session_by_format: 'format',
  filter_session_by_language: 'language',
  filter_session_by_level: 'level',
  filter_session_by_track: 'track',
  filter_session_by_tags: 'tags',
  filter_session_by_location: 'location',
};

export const FIXED_SESSION_FIELD_IDS = [
  'title',
  'description',
  'date',
  'location',
  'speakers',
  'starts_at',
  'ends_at',
  'created_at',
  'ceu_credits',
];

export const FIXED_SPEAKER_FIELD_IDS = ['full_name', 'about', 'photo', 'title', 'company'];

// Global pagination constant
export const ITEMS_PER_PAGE = 25;

export const SPEAKER_ROLE_TYPES = {
  SPEAKER: 'speaker',
  CHAIRPERSON: 'chairperson',
  MODERATOR: 'moderator',
};

// SB-8853: canonical display order for the reserved trio; custom role slugs
// render after these in payload order.
export const RESERVED_ROLE_SLUGS = [
  SPEAKER_ROLE_TYPES.SPEAKER,
  SPEAKER_ROLE_TYPES.MODERATOR,
  SPEAKER_ROLE_TYPES.CHAIRPERSON,
];
